import { useLayoutEffect, useRef } from 'react'
import useResizeObserver from '@react-hook/resize-observer'
import { senMessagedResizeFrame } from '../util/messageHandler'

export const useResizeFrame = () => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  useLayoutEffect(() => {
    if (!containerRef.current) return

    if (containerRef.current.getBoundingClientRect()) {
      const entry = containerRef.current.getBoundingClientRect()
      senMessagedResizeFrame(entry.height, entry.width)
    }
  }, [])

  // Where the magic happens
  useResizeObserver(containerRef, (entry) => {
    senMessagedResizeFrame(entry.contentRect.height, entry.contentRect.width)
  })
  return { containerRef }
}
